
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-212fa545&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AlertAtualizacoes.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AlertAtualizacoes.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-212fa545!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AlertAtualizacoes.vue"),
  /* scopeId */
  "data-v-212fa545",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modal/AlertAtualizacoes.vue
// module id = 491
// module chunks = 1